import { useEffect, useRef } from "react";
import * as QRCode from "qrcode";

// Draws the QR code of the link on the returned canvas
export const useQrCodeCanvas = (link: string | undefined) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current || !link) {
      return;
    }

    QRCode.toCanvas(canvasRef.current, encodeURI(link)).catch(error =>
      console.error("Error while generating the QR code", error)
    );
  }, [link]);

  return canvasRef;
};
